<template>
  <div class="list_index">
      <el-button
        type="primary"
        icon="el-icon-plus"
        size="mini"
        class="yl-button"
        @click="handleAdd" 
      >新增</el-button>
      <el-table stripe border :data="tableData">
        <el-table-column label="故障类型" prop="faultType"></el-table-column>
        <el-table-column label="操作">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="删除" placement="top">
                <el-button type="text" icon="el-icon-sc" size="small" @click="deleteFaultType(scope.row)"></el-button>
              </el-tooltip>
            </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
        layout="total, prev, pager, next, jumper"
        :current-page="page"
        :page-size="size"
        :total="count"
        @current-change="changePage"
        ></el-pagination>
      </div>
       <el-dialog title="新增故障类型" :visible.sync="showfaultType" width="30%">
        <el-form :model="form" label-width=".8rem" ref="faultType" :rules="rules">
          <el-form-item label="故障类型" prop="faultType">
            <el-input type="text" class="yl-input_noIcon" size="small" placeholder="请输入故障类型" v-model="form.faultType" ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" size="mini" class="yl-button" @click="submit()">确 定</el-button>
            <el-button @click="canel" size="mini" class="yl-button2">取 消</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
import RepairService from '@/api/repair';
export default {
    data(){
        return{
            page: 1,
            count: 0,
            size:10,
            form:{
                faultType:'',
            },
            tableData:[],
            showfaultType:false,
            rules:{
                faultType:[{ required: true,message: '请输入故障类型', trigger: 'blur' }],
            },
        }
    },
    methods:{
        handleAdd(){
            this.showfaultType = true;
        },
        edit(val){
            this.showfaultType = true;
        },
        //获取表格数据
        getDataList(){
            RepairService.getFaultType({
                user_id:this.$store.state.user_id,
                page:this.page,
                size:this.size
            }).then(res=>{
                this.tableData = res.data.projectSiteList;
                this.count = res.data.count;
            }).catch(err=>{
                this.$message.error(err.message)
            })
        },
        //提交表单
        submit(){
          this.$refs.faultType.validate((valid)=>{
            if(valid){
            RepairService.addFaultType({
                ...this.form,
                 user_id:this.$store.state.user_id
                }).then(res=>{
                this.$message.success('新增成功')
                this.resetForm('faultType');
                this.showfaultType = false;
                this.getDataList();
            }).catch(err=>{
                this.$message.error(err.message)
            })
            }else{
                this.$message.error("请检查必填项");
                return false;
            }
          })
        },
        canel(){
            this.showfaultType = false;
            this.resetForm('faultType');
        },
        changePage(page) {
          this.page = page;
          this.getDataList();
        },
        //删除项目现场
        deleteFaultType(val){
          let _this = this;
          this.$confirm('是否确认删除故障类型为"' + val.faultType + '"的数据项?', "警告", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }).then(function() {
              RepairService.deleteFaultType({
                user_id:_this.$store.state.user_id,
                faultType:val.faultType
              }).then(res=>{
                _this.$message.success('删除成功')
                _this.getDataList()
              }).catch(err=>{
                _this.$message.error(err.message)
              })
            })
        },
    },
    mounted(){
        this.getDataList()
    }
}
</script>

<style>

</style>